import {
  ProCurrency,
  ProDetailList,
  ProText,
  ProTextArea,
} from '@bedrock/eed-react';
import {
  FormCard,
  FormItemBaseEnum,
  FormItemBaseFile,
  FormModule,
  SupplierDetailList,
} from '@purchase/supplier';
import React, { FC } from 'react';
import { ProxyListTable } from './ProxyListTable';
import { ProCustomFieldDateRange } from '../../components/ProCustomFieldDateRange';
import { ProTextPercentage } from '../../components/ProTextPercentage';

export const IndustryExperience: FC<{
  isExternal?: boolean;
  formDetail?: any;
  mode?: 'card' | 'module';
  namePath?: string[];
  vendorId: string;
}> = (props) => {
  const { isExternal = false, mode = 'card', formDetail, vendorId } = props;
  const Wrapper = mode === 'card' ? FormCard : FormModule;

  const successCaseCount =
    formDetail?.extendAttributeInfo?.successCase?.length ?? 0;
  const topCustomerCount =
    formDetail?.extendAttributeInfo?.topCustomer?.length ?? 0;

  return (
    <Wrapper title="行业经验">
      <FormModule
        title="成功案例"
        titleCount={successCaseCount}
        proCardProps={{
          expandable: true,
          defaultExpanded: successCaseCount > 0,
        }}
      >
        <SupplierDetailList
          name={['extendAttributeInfo', 'successCase']}
          fieldProps={{ scroll: { x: 1120 }, className: 'mb-[8px]' }}
        >
          <ProDetailList.Item
            label="#"
            name="#"
            meta={{ columnProps: { width: 50, fixed: true } }}
          >
            {(_, record) => {
              return {
                children: record?.$index + 1,
                props: {
                  rowSpan: record?.$rowSpan || 0,
                },
              };
            }}
          </ProDetailList.Item>
          <ProDetailList.Item
            label="行业类型"
            name={['industryType']}
            meta={{
              columnProps: {
                width: 200,
                className: 'font-semibold',
                fixed: true,
              },
            }}
          >
            {(_, record) => {
              return {
                children: <FormItemBaseEnum name={['industryType']} />,
                props: {
                  rowSpan: record?.$rowSpan || 0,
                },
              };
            }}
          </ProDetailList.Item>
          <ProDetailList.Item label="成功案例" name="successCaseContent">
            <ProTextArea />
          </ProDetailList.Item>
          <ProDetailList.Item
            label="附件"
            name="successCaseAttachment"
            meta={{ columnProps: { width: 240 } }}
          >
            <FormItemBaseFile />
          </ProDetailList.Item>
        </SupplierDetailList>
      </FormModule>
      <FormModule
        title="头部客户"
        titleCount={topCustomerCount}
        proCardProps={{
          expandable: true,
          defaultExpanded: topCustomerCount > 0,
        }}
      >
        <SupplierDetailList
          name={['extendAttributeInfo', 'topCustomer']}
          formItemProps={{
            className: 'mb-[0px]',
          }}
          fieldProps={{ scroll: { x: 1120 } }}
        >
          <ProDetailList.Item
            label="#"
            name="#"
            meta={{ columnProps: { width: 50, fixed: true } }}
          >
            {(value, record, index) => {
              return index + 1;
            }}
          </ProDetailList.Item>
          <ProDetailList.Item
            label="主要客户名称"
            name="customerName"
            meta={{
              columnProps: {
                width: 200,
                className: 'font-semibold',
                fixed: true,
              },
            }}
          >
            <ProText />
          </ProDetailList.Item>
          <ProDetailList.Item label="服务类型及内容" name="serviceTypeContent">
            <ProText />
          </ProDetailList.Item>
          <ProDetailList.Item
            label="合作期间"
            name="coopPeriod"
            meta={{ columnProps: { width: 200 } }}
          >
            <ProCustomFieldDateRange />
          </ProDetailList.Item>
          <ProDetailList.Item
            label="近两年收入金额（万）"
            name={['incomeAmountForTwoYears']}
            meta={{ columnProps: { width: 180 } }}
          >
            <ProCurrency
              valueFormat={{
                valueToField: (value: any, fieldProps: any) => {
                  if (value && value?.currency?.value) {
                    return { ...value, currency: value?.currency?.value };
                  }
                  return value;
                },
              }}
            />
          </ProDetailList.Item>
          <ProDetailList.Item
            label="近两年收入占比"
            name={['incomeProportionForTwoYears']}
            meta={{ columnProps: { width: 180 } }}
          >
            <ProTextPercentage />
          </ProDetailList.Item>
        </SupplierDetailList>
      </FormModule>
      {/* 代理清单 - 仅内包端展示 */}
      {!isExternal && <ProxyListTable vendorId={vendorId} />}
    </Wrapper>
  );
};
